<template>
  <div class="swipeHint">
    <Popup :close-on-click-overlay="false" class="popup_box" v-model="isShow">
      <div class="container">
        <img :src="images[imagesIndex]" alt="" />
        <!-- <div class="container_box" v-if="imagesIndex == 0">
          <div class="container_title">Thận trọng!</div>
          <div class="container_desc">
            Thẻ vàng hạnh phúc sẽ không yêu cầu bạn trả nợ cho bất kỳ thẻ ngân
            hàng cá nhân nào. Nếu bạn tìm thấy nó, đó là một sự gian lận. Xin
            vui lòng Liên hệ với dịch vụ khách hàng nền tảng. Vui lòng đăng nhập
            vào ứng dụng để xem số thẻ trả nợ được chỉ định chính thức
          </div>
        </div>
        <div class="container_box container_box2" v-if="imagesIndex == 1">
          <div class="container_title">Thẻ Vàng Hạnh Phúc</div>
          <div class="container_desc">
            Happiness Gold Thẻ là một nền tảng công nghệ dịch vụ tài chính
            trưởng thành cam kết cung cấp đơn giản, nhanh chóng và an toàn Kinh
            nghiệm người dùng.
          </div>
        </div>
        <div class="container_box container_box3" v-if="imagesIndex == 2">
          <div class="container_title">Duy trì bảo mật thông tin của bạn</div>
          <div class="container_desc">
            Thẻ vàng hạnh phúc sẽ không yêu cầu bạn trả nợ cho bất kỳ thẻ ngân
            hàng cá nhân nào. Nếu bạn tìm thấy nó, đó là một sự gian lận. Xin
            vui lòng Liên hệ với dịch vụ khách hàng nền tảng. Vui lòng đăng nhập
            vào ứng dụng để xem số thẻ trả nợ được chỉ định chính thức
          </div>
        </div> -->
      </div>

      <div class="popup_close">
        <img @click="closePopup" src="@/assets/home/guanbi@2x.png" alt="" />
      </div>
    </Popup>
  </div>
</template>

<script>
import { Popup } from "vant";
export default {
  name: "swipeHint",
  components: { Popup },
  props: {
    imageIndex: {
      type: [String, Number],
      default: "0",
    },
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShow: this.show,
      images: [
        require("@/assets/home/popup1.png"),
        require("@/assets/home/popup2.png"),
        require("@/assets/home/popup3.png"),
      ],
      imagesIndex: 0,
    };
  },
  watch: {
    show(newVal) {
      this.isShow = newVal;
    },
    imageIndex(newVal) {
      this.imagesIndex = newVal;
    },
  },
  methods: {
    closePopup() {
      this.isShow = false;
      this.$emit("closePopup");
    },
  },
};
</script>

<style lang="less" scoped>
.swipeHint {
  /deep/ .van-overlay {
  background: rgba(101, 101, 101, 0.2);
  backdrop-filter: blur(3px);
  }
}
.popup_box {
  width: 282px;
  height: 361px;
  border-radius: 11px;
  box-sizing: border-box;
  background: none;
  .container {
    position: relative;
    height: 361px;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .container_box {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      .container_title {
        margin-top: 38px;
        text-align: center;
        font-size: 21px;
        color: #ebcfa4;
      }
      .container_desc {
        margin: 0 auto;
        padding-top: 20px;
        width: 213px;
        height: 68px;
        font-size: 12px;
        color: #ebcfa4;
      }
    }
    .container_box2 {
      .container_title {
        color: #f4431c;
      }
      .container_desc {
        color: #f4431c;
      }
    }
    .container_box3 {
      .container_title {
        color: #ebcfa4;
      }
      .container_desc {
        color: #ebcfa4;
      }
    }
  }
  .popup_close {
    position: absolute;
    top: 20px;
    right: 20px;
    img {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
